import { render, staticRenderFns } from "./listaCategoriaPromocion.vue?vue&type=template&id=2f2fd9d2&scoped=true"
import script from "./listaCategoriaPromocion.vue?vue&type=script&lang=js"
export * from "./listaCategoriaPromocion.vue?vue&type=script&lang=js"
import style0 from "./listaCategoriaPromocion.vue?vue&type=style&index=0&id=2f2fd9d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2fd9d2",
  null
  
)

export default component.exports